import React, { useState } from "react";
import Modal, { modalStyles as m } from "./Modal";
import { ToastifyAlert } from "../../../CommonComponents/ToastifyAlert";
import { phpDropCash, phpPayInCash } from "../data/api";
import { fmt } from "../uiUtils";

// Android showCashDropDialog / showPayInDialog: the keyed amount is fixed, a reason is REQUIRED,
// then Shift_inout/drop_cash | payin_cash. Strings are the POS's own.
const KINDS = {
  drop: {
    title: "Drop Cash",
    reasonLabel: "Reason for Drop Cash",
    hint: "E.g.,Safe deposit, excess cash, or refund.",
    missing: "Enter reason for drop cash",
    button: "Drop Cash",
    success: "Cash Dropped Successfully",
    call: phpDropCash,
  },
  payin: {
    title: "Pay In",
    reasonLabel: "Reason for Cash Pay in",
    hint: "E.g Adding changes, correcting balance",
    missing: "Enter reason for pay in",
    button: "Pay In",
    success: "Cash Pay In Successfully",
    call: phpPayInCash,
  },
};

export default function CashOpModal({ kind, amount, onDone, onClose }) {
  const k = KINDS[kind] || KINDS.drop;
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!reason.trim()) return ToastifyAlert(k.missing, "error");
    if (typeof navigator !== "undefined" && navigator.onLine === false) return ToastifyAlert("No internet connection", "error");
    setBusy(true);
    try {
      const res = await k.call({ amount: Number(amount).toFixed(2), reason: reason.trim() });
      if (res && (res.status === true || String(res.status) === "1" || String(res.status).toLowerCase() === "true")) {
        ToastifyAlert(k.success, "success");
        onDone(res);
      } else {
        ToastifyAlert((res && res.message) || "Oops! Something went wrong", "error");
        onClose();
      }
    } catch {
      ToastifyAlert("Oops! Something went wrong", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title={k.title} onClose={onClose}>
      <div style={m.label}>Amount</div>
      <div style={{ fontSize: 28, fontWeight: 800, letterSpacing: "-0.01em", margin: "4px 0 12px" }}>{fmt(amount)}</div>
      <div style={m.label}>{k.reasonLabel}</div>
      <input
        style={m.input}
        autoFocus
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={k.hint}
        onKeyDown={(e) => e.key === "Enter" && submit()}
      />
      <button style={m.primary} disabled={busy} onClick={submit}>{busy ? "Saving…" : k.button}</button>
      <button style={m.ghost} disabled={busy} onClick={onClose}>Cancel</button>
    </Modal>
  );
}
